var map = {
	"./bg/translation.json": 8742,
	"./cs/translation.json": 9847,
	"./da/translation.json": 7030,
	"./de/translation.json": 8186,
	"./el/translation.json": 1024,
	"./en/translation.json": 2610,
	"./es/translation.json": 7585,
	"./et/translation.json": 3064,
	"./fi/translation.json": 9508,
	"./fr/translation.json": 8681,
	"./ga/translation.json": 7341,
	"./hr/translation.json": 2960,
	"./hu/translation.json": 9526,
	"./it/translation.json": 9316,
	"./lt/translation.json": 3517,
	"./lv/translation.json": 1499,
	"./mt/translation.json": 8144,
	"./nl/translation.json": 9131,
	"./pl/translation.json": 6401,
	"./pt/translation.json": 6153,
	"./ro/translation.json": 8030,
	"./sk/translation.json": 991,
	"./sl/translation.json": 4170,
	"./sv/translation.json": 1008,
	"./zh-hans/translation.json": 3098
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2228;